export enum BankStatus {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  CLOSED = 'Closed',
}
